import {Component, OnInit} from '@angular/core';
import {
  FormBuilderService,
  ApplicationService,
  NotificationService,
  WorkbookService,
  CommunicationService,
  SalesService, TypesService
} from '../../services/index';
import {WizardFormComponent, WizardSteps} from './wizard-form.component';
import {BaseSubmissionModel} from '../../models/submission/base-submission-model';
import { UntypedFormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {IndividualPersonModel} from '../../models/widgets/personal-details-model';
import {IndividualCompanyModel} from '../../models/widgets';
import {IndividualTrustModel} from '../../models/widgets/trust-details-model';
import {DomSanitizer} from '@angular/platform-browser';
import {SubmissionService} from '../../services/submission.service';
import {OAuthService} from 'angular-oauth2-oidc';
import {Router, ActivatedRoute} from '@angular/router';
import {environment} from '../../../environments/environment';
import {LCA_ORIGINATOR_PARTY_ROLE_ID} from '../../_global/wiz.constants';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrokerNotesComponent } from '../widgets/broker-notes/broker-notes.component';
import { ProductComponent } from '../widgets/product/product.component';
import { RateComponent } from '../widgets/rate/rate.component';
import { SolicitorBorrowerDetailsComponent } from '../widgets/solicitor-borrower-details/solicitor-borrower-details.component';
import { SolicitorPanelDetailsComponent } from '../widgets/solicitor-panel-details/solicitor-panel-details.component';
import { SecurityDetailsComponent } from '../widgets/security-details/security-details.component';
import { HomeLoanDetailsComponent } from '../widgets/home-loan-details/home-loan-details.component';
import { ApplicationTypeComponent } from '../widgets/application-type/application-type.component';
import { LoanDetailsTermsComponent } from '../widgets/loan-details-terms/loan-details-terms.component';
import { QuotesListComponent } from '../widgets/quotes-list/quotes-list.component';
import { QuoteDetailsComponent } from '../widgets/quote-details/quote-details.component';
import { ConfirmationComponent } from '../widgets/confirmation/confirmation.component';
import { SubmitComponent } from '../widgets/submit/submit.component';
import { DocumentUploadComponent } from '../widgets/documents-upload/documents-upload.component';
import { AutoCollateralComponent } from '../widgets/auto-collateral/auto-collateral.component';
import { ExpensesDetailsComponent } from '../widgets/expense-details/expenses-details.component';
import { LiabilitiesDetailsComponent } from '../widgets/liabilities-details/liabilities-details.component';
import { AssetsDetailsComponent } from '../widgets/assets-details/assets-details.component';
import { IncomeDetailsComponent } from '../widgets/income-details/income-details.component';
import { InvestmentIncomeComponent } from '../widgets/investment-income/investment-income.component';
import { EmploymentDetailsComponent } from '../widgets/employment-details/employment-details.component';
import { BalloonAmountComponent } from '../widgets/balloon-amount/balloon-amount.component';
import { LoanTermsComponent } from '../widgets/loan-terms/loan-terms.component';
import { SingleSplitLoanAmountComponent } from '../widgets/single-split-loan-amount/single-split-loan-amount.component';
import { LoanDetailsComponent } from '../widgets/loan-details/loan-details.component';
import { BusinessCarLoanDetailsComponent } from '../widgets/business-car-loan-details/business-car-loan-details.component';
import { PersonalDetailsComponent } from '../widgets/personal-details/personal-details.component';
import { CompanyDetailsComponent } from '../widgets/company-details/company-details.component';
import { TrustDetailsComponent } from '../widgets/trust-details/trust-details.component';
import { BorrowerTypeEnhancedComponent } from '../widgets/borrower-type-enhanced/borrower-type-enhanced.component';
import { BorrowerTypeComponent } from '../widgets/borrower-type/borrower-type.component';
import { AbnAcnComponent } from '../widgets/abn-acn/abn-acn.component';
import { CustomerDetailsComponent } from '../widgets/customer-details/customer-details.component';
import { OriginatorBrokerComponent } from '../widgets/originator-broker/originator-broker.component';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgClass, NgIf, NgFor } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import {DataHandlerService} from '../../services/data-handler.service';

@Component({
    templateUrl: './wizard-form.component.html',
    standalone: true,
    imports: [MatSidenavModule, NgClass, MatProgressBarModule, NgIf, MatListModule, NgFor, MatButtonModule, MatButtonModule, FormsModule, OriginatorBrokerComponent, ReactiveFormsModule, CustomerDetailsComponent, AbnAcnComponent, BorrowerTypeComponent, BorrowerTypeEnhancedComponent, TrustDetailsComponent, CompanyDetailsComponent, PersonalDetailsComponent, BusinessCarLoanDetailsComponent, LoanDetailsComponent, SingleSplitLoanAmountComponent, LoanTermsComponent, BalloonAmountComponent, EmploymentDetailsComponent, InvestmentIncomeComponent, IncomeDetailsComponent, AssetsDetailsComponent, LiabilitiesDetailsComponent, ExpensesDetailsComponent, AutoCollateralComponent, DocumentUploadComponent, SubmitComponent, ConfirmationComponent, QuoteDetailsComponent, QuotesListComponent, LoanDetailsTermsComponent, ApplicationTypeComponent, HomeLoanDetailsComponent, SecurityDetailsComponent, SolicitorPanelDetailsComponent, SolicitorBorrowerDetailsComponent, RateComponent, ProductComponent, BrokerNotesComponent, MatProgressSpinnerModule, MatProgressSpinnerModule]
})
export class BusinessAutoComponent extends WizardFormComponent implements OnInit {

  public wizardName = 'Business Auto Loan';
  public baseModel: BaseSubmissionModel;
  public storageIdentifier = 'wiz-business-auto'; // the key for session storage
  public loanPurposeType = 'business-vehicle';
  public salesRelatesTo = 'business-car-loan';
  public blurbUrl = '/general_terms_default.html';
  public blurbText = '';
  public isPersonalLoan = false;
  public steps: WizardSteps[] = [{
    icon: 'arrow_forward',
    name: 'Your details',
    widgets: [
      {name: 'app-originator-broker', class: 'col-sm-12'},
      {name: 'app-customer-details', class: 'col-sm-12'},
      {name: 'app-abn-acn', class: 'col-sm-12'},
      {name: 'app-borrower-type', class: 'col-sm-12'}
    ],
    classNameStatus: 'default'
  }, {
    icon: 'arrow_forward',
    name: 'Company details',
    widgets: [
      {name: 'app-trust-details', class: 'col-sm-12'},
      {name: 'app-company-details', class: 'col-sm-12'},
      {name: 'app-personal-details', class: 'col-sm-12'},
    ],
    classNameStatus: 'default'
  }, {
    icon: 'arrow_forward',
    name: 'Loan details',
    // widgets: ['app-business-car-loan-details']
    widgets: [
      {name: 'app-loan-details-terms', class: 'col-sm-6', opts: {vehicleUsage: 'business'}},
      {name: 'app-single-split-loan-amount', class: 'col-sm-6'},
      {name: 'app-rate', class: 'col-sm-12'}
    ],
    classNameStatus: 'default'
  }, {
    icon: 'arrow_forward',
    name: 'Assets & Liabilities details',
    condition: (WizardFormComponent) => {
      return WizardFormComponent.personalDetails.value.find(x => x.ownProperty === true) || false;
    },
    widgets: [
      {name: 'app-assets-details', class: 'col-sm-12'},
      {name: 'app-liabilities-details', class: 'col-sm-12'},
      {name: 'app-expenses-details', class: 'col-sm-12'}
    ],
    classNameStatus: 'default'
  }, {
    icon: 'arrow_forward',
    name: 'Submission',
    widgets: [
      {name: 'app-submit', class: 'col-sm-12'},
      {name: 'app-docs-upload', class: 'col-sm-12'},
      {name: 'app-broker-notes', class: 'col-sm-12'}
    ],
    classNameStatus: 'default'
  }, {
    icon: 'arrow_forward',
    name: 'Confirmation',
    widgets: [
      {name: 'app-confirmation', class: 'col-sm-12'}
    ],
    classNameStatus: 'default'
  }];

  constructor(public formBuilderService: FormBuilderService,
              public dataHandlerService: DataHandlerService,
              public submissionService: SubmissionService,
              public applicationService: ApplicationService,
              public notificationService: NotificationService,
              public sanitizer: DomSanitizer,
              public oauthService: OAuthService,
              public router: Router,
              public activatedRoute: ActivatedRoute,
              public workbookService: WorkbookService,
              public typesService: TypesService,
              public communicationService: CommunicationService,
              public salesService: SalesService) {

    super(formBuilderService, dataHandlerService, submissionService, applicationService, notificationService, sanitizer,
      oauthService, router, activatedRoute, workbookService, typesService, communicationService, salesService);
    console.log('[business-auto]', 'Init Business Auto Application');
    console.log('[storageIdentifier]', this.storageIdentifier);
    // this.baseModel = new BusinessAutoModel(this.defaultData);
  }

  public ngOnInit() {
    super.ngOnInit();
    if (this.baseform && this.baseform.get('step-1')) {
      // set the details based on the step where they are located
      this.trustDetails = (this.baseform.get('step-1').get('app-trust-details').get('trustList') as UntypedFormArray);
      this.companyDetails = (this.baseform.get('step-1').get('app-company-details').get('companyList') as UntypedFormArray);
      this.personalDetails = (this.baseform.get('step-1').get('app-personal-details').get('personList') as UntypedFormArray);
      this.setListValidators();
    }

    // get blurb
    // this.applicationService.getBlurb(environment.blurbBaseUrl + this.blurbUrl)
    //   .subscribe(result => {
    //     this.blurbText = result.toString();
    //   });
  }

  public getGeneralBlurb() {
    if (this.blurbText === '') {
      return this.sanitizer.bypassSecurityTrustHtml(
        `<div>
        <h5>I confirm</h5>
        <ul>
          <li>The vehicle that is the subject of the application will be used wholly or predominantly for personal use</li>
          <li>The information that I have provided in this loan application is true and correct</li>
          <li>I have read the privacy declaration and consent to Firstmac collecting, using and providing my personal details and credit information to process my loan application in accordance with those terms</li>
        </ul>
        </div>`
      );
    } else {
      return this.sanitizer.bypassSecurityTrustHtml(`${this.blurbText}`);
    }
  }

  private setListValidators() {
    this.trustDetails.controls.forEach(fg => {
      this.formBuilderService.setValidationRules(new IndividualTrustModel(), fg);
    });
    this.companyDetails.controls.forEach(fg => {
      this.formBuilderService.setValidationRules(new IndividualCompanyModel(), fg);
    });
    this.personalDetails.controls.forEach(fg => {
      this.formBuilderService.setValidationRules(new IndividualPersonModel(), fg);
    });
  }

  public updateAbnRecord(company) {
    // console.log('[updateAbnRecord]', company);

    // get ACN
    let _companyACN = '';
    if (company['organisation-number-heading'] && company['organisation-number-heading']['_text'] === 'ACN') {
      _companyACN = company['organisation-number']['_text'];
      // console.log('ACN:', _companyACN);
    }
    // get entity type (needed for borrower type)
    const _entity = {
      ind: (company['australian-business-register-report']['EntityTypeInd'] ? company['australian-business-register-report']['EntityTypeInd']['_text'] : ''),
      text: (company['australian-business-register-report']['EntityTypeText'] ? company['australian-business-register-report']['EntityTypeText']['_text'] : '')
    };
    // get asic report details (ext)
    const _asic = {
      asicorganisationnumberheadingField: (company['australian-business-register-report']['organisation-number-heading'] ? company['australian-business-register-report']['organisation-number-heading']['_text'] : ''),
      asicorganisationnumberField: (company['australian-business-register-report']['organisation-number'] ? company['australian-business-register-report']['organisation-number']['_text'] : ''),
      asicbusinessregistrationnumberField: '',
      aSICNumberField: (company['australian-business-register-report']['ASICNumber'] ? company['australian-business-register-report']['ASICNumber']['_text'] : ''),
      aBNStatusFromDateField: (company['australian-business-register-report']['ABNStatusFromDate'] ? company['australian-business-register-report']['ABNStatusFromDate']['_text'] : '')
    };
    if (_asic.aBNStatusFromDateField) {
      _asic['aBNStatusFromDateFieldSpecified'] = true;
    } else {
      _asic['aBNStatusFromDateFieldSpecified'] = false;
    }
    // save selected company
    this.selectedCompany = {
      name: company['match-name']._text,
      abn: company['australian-business-number']._text,
      acn: _companyACN,
      entity: _entity,
      asic: _asic
    };

    console.log('[selectedCompany]', this.selectedCompany);
    this.populateCompanyDetailsFromAbn();
  }

  populateCompanyDetailsFromAbn() {
    // console.log('[populateCompanyDetailsFromAbn]');

    if (this.trustDetails.length > 0) {
      this.trustDetails.at(0).patchValue({
        trustName: this.selectedCompany.name,
        trustABN: this.selectedCompany.abn,
        // trustACN: this.selectedCompany.acn,
        ext: this.selectedCompany.asic
      });
    } else if (this.companyDetails.length > 0) {
      this.companyDetails.at(0).patchValue({
        companyName: this.selectedCompany.name,
        companyABN: this.selectedCompany.abn,
        companyACN: this.selectedCompany.acn,
        ext: this.selectedCompany.asic
      });
    } else if (this.personalDetails.length > 0) {
      // assuming sole-trader or partnership
      this.personalDetails.at(0).patchValue({
        orgName: this.selectedCompany.name,
        orgABN: this.selectedCompany.abn,
        ext: this.selectedCompany.asic,
        showPersonABN: true
      });
    }
  }

  public handleSelectedTrustCompany(record) {
    // console.log('[handleSelectedTrustCompany]', record);
    if (this.companyDetails.length > 0) {
      // add ext
      const _asic = {
        asicorganisationnumberheadingField: (record['australian-business-register-report']['organisation-number-heading'] ? record['australian-business-register-report']['organisation-number-heading']['_text'] : ''),
        asicorganisationnumberField: (record['australian-business-register-report']['organisation-number'] ? record['australian-business-register-report']['organisation-number']['_text'] : ''),
        asicbusinessregistrationnumberField: '',
        aSICNumberField: (record['australian-business-register-report']['ASICNumber'] ? record['australian-business-register-report']['ASICNumber']['_text'] : ''),
        aBNStatusFromDateField: (record['australian-business-register-report']['ABNStatusFromDate'] ? record['australian-business-register-report']['ABNStatusFromDate']['_text'] : '')
      };
      if (_asic.aBNStatusFromDateField) {
        _asic['aBNStatusFromDateFieldSpecified'] = true;
      } else {
        _asic['aBNStatusFromDateFieldSpecified'] = false;
      }

      this.companyDetails.at(0).patchValue({
        companyName: record['match-name']._text,
        companyABN: record['australian-business-number']._text,
        companyACN: record['organisation-number']['_text'],
        ext: _asic
      });
    }
  }

  /**
   * Hook into before submit to do form-specific logic
   * @param data
   */
  public formBeforeSubmit(data) {
    const packet = super.formBeforeSubmit(data);

    packet.lead.source = environment.auth.active.source;
    packet.lead.productCategory = 'motor-vehicle';

    if (!packet.parties.find(x => x.value === LCA_ORIGINATOR_PARTY_ROLE_ID && x.referenceType === 'partyRoleId')) {
      packet.lead.status = 'live-app';
    }
    return packet;
  }

}
